import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ViewFileIcon } from "../../../../Icons/ViewFileIcon";
import { DownloadIcon } from "../../../../Icons/DownloadIcon";
import * as _ser from "../../../../_redux/_services/JobPostingSlice";
import DetailCard from "../../../../components/DetailCard/DetailCard";
import Pagination from "../../../../components/DynamicTable/Pagination";
import { DashboardPlusicon } from "../../../../Icons/DashboardPlusicon";
import DeleteIcon from "@mui/icons-material/Delete";
import WarningPopup from "../../../../components/WarningPopup/WarningPopup";
import AddJobpostingDetailsDocuments from "./AddJobpostingDetailsDocuments";
import "./JobpostingDetailsDocuments.css";
import RightSideBar from "../../../../components/Rightsidebar/RightSideBar";
import { AddDocumentsillus } from "../../../../Icons/AddDocumentsillus";
import { openDocumentInNewTab } from "../../../../_utilities/utilities";

const CARDS_PER_PAGE = 6;

const initalState = { data: null, message: "", isloader: true };

const JobpostingDetailsDocuments = ({ data, selectedJob, onReceiveProps }) => {
  const [open, setOpen] = useState(false);
  const [docObj, setDocObj] = useState("");
  const [DocName, setDocName] = useState("");
  const [documents, setDocuments] = useState([]);
  const [actionType, setActionType] = useState("");
  const [HandlerType, setHandlerType] = useState("");
  const [previewType, setPreviewType] = useState("");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [docToDelete, setDocToDelete] = useState(null);
  const [warningPopupDetails, setWarningPopupDetails] = useState({
    title: "",
    btnName: "",
    type: "",
  });

  const warningPopupEnum = {
    DELETE: {
      title: "Are you sure you want to delete this document?",
      btnName: "Delete",
      type: "delete",
    },
  };
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [isValidUser, setIsValidUser] = useState(false);
  const [fileExtention, setFileExtention] = useState("");
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const code = useSelector((state) => state.Deletedocuments.data);
  const docData = useSelector((state) => state.DownloadFileFromS3.data);

  useEffect(() => {
    if (data !== null) {
      setDocuments(data);
      setCurrentPage(1);
    }
  }, [data]);

  // ─── Paginated data ───
  const paginatedDocs = useMemo(() => {
    const start = (currentPage - 1) * CARDS_PER_PAGE;
    return documents.slice(start, start + CARDS_PER_PAGE);
  }, [documents, currentPage]);

  // ─── Build card body fields for each document ───
  const buildDocFields = useCallback((doc) => {
    const fields = [];

    const iconType =
      (doc.docType || "").toLowerCase() === "doc" ||
      (doc.docType || "").toLowerCase() === "docx"
        ? "doc"
        : "pdf";
    fields.push({
      icon: iconType,
      value: doc.documentName + doc.documentType || doc.name + doc.docType || "-",
    });

    fields.push({
      value: doc.date || "-",
    });

    return fields;
  }, []);

  // ─── Build footer actions for each document ───
  const buildDocActions = useCallback(
    (doc) => [
      {
        key: "view",
        icon: <ViewFileIcon />,
        label: "View",
        tooltip: "View",
        onClick: () => {
          setSelectedDoc(doc);
          DownloadFileFromS3(doc, "view");
          setHandlerType("view");
          setIsRightSidePannel(true);
        },
      },
      {
        key: "download",
        icon: <DownloadIcon />,
        label: "Download",
        tooltip: "Download",
        onClick: () => DownloadFileFromS3(doc, "download"),
      },
      ...((doc.docType || doc.documentType || "Resume").toLowerCase() ===
      "resume"
        ? [
            {
              key: "star",
              icon:
                doc.primaryResume === 1 ? (
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assests/img/primary-star-inside-circle.svg"
                    }
                    alt="Primary"
                    style={{ width: 16, height: 16 }}
                  />
                ) : (
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assests/img/star-inside-circle.svg"
                    }
                    alt="Mark as Primary"
                    style={{ width: 16, height: 16 }}
                  />
                ),
              tooltip:
                doc.primaryResume === 1
                  ? "Primary Document"
                  : "Mark as Primary",
              onClick:
                doc.primaryResume === 1
                  ? undefined
                  : () => {
                      setOpen(true);
                      setDocObj(doc);
                    },
            },
          ]
        : []),
      {
        key: "openNew",
        icon: (
          <img
            src={process.env.PUBLIC_URL + "/assests/img/newtabIcon.svg"}
            alt="Primary"
            style={{ width: 14, height: 14 }}
          />
        ),
        tooltip: "Open in new tab",
        onClick: () => DownloadFileFromS3(doc, "viewDocumentNewPage"),
      },
      {
        key: "delete",
        icon: <DeleteIcon style={{ width: 18, height: 18 }} />,
        tooltip: "Delete",
        onClick: () => {
          setDocToDelete(doc);
          setWarningPopupDetails(warningPopupEnum.DELETE);
          setShowDeleteConfirm(true);
        },
      },
    ],
    [selectedJob],
  );

  const handleClose = () => {
    setOpen(false);
  };

  // useEffect(() => {
  //   if (updateResumeData.code === 209 && updateResumeData.updatedata) {
  //     let obj = { ...updateResumeData.updatedata[0] };
  //     obj["message"] = updateResumeData.message;
  //     obj["id"] = updateResumeData.id;
  //     obj["oldApplicantName"] = updateResumeData.oldApplicantName;
  //     dispatch(_ser.uploadDocumentsStartReducer(initalState));
  //     const state = { applicant: obj, docId: docObj.id, isOverwriteEdit: true };
  //     onReceiveProps("edit", state);
  //   } else if (updateResumeData.code === 210) {
  //     setOpen(false);
  //     dispatch(
  //       updateSnackbar({ type: "error", message: updateResumeData.message }),
  //     );
  //     let data = [...documents];
  //     data.forEach((list) => {
  //       list["isChecked"] = false;
  //     });
  //     setDocuments(data);
  //     dispatch(_ser.uploadDocumentsStartReducer(initalState));
  //   }
  // }, [updateResumeData]);

  const DeleteDocuments = async (object) => {
    let obj = { file_ids: [object.id.toString()] };
    dispatch(_ser.deletedocumentsAsync(selectedJob, obj));
  };

  useEffect(() => {
    if (code === 200) {
      onReceiveProps("documents");
      dispatch(_ser.deletedocumentsStartReducer(initalState));
    }
  }, [code]);

  const DownloadFileFromS3 = async (object, type) => {
    const actiontypeToApi =
      type === "Download" || type === "download" ? "download" : "preview";
    const actiontype =
      type === "Download" || type === "download"
        ? "download"
        : type === "view"
          ? "preview"
          : type;
    setActionType(actiontype);
    setDocName(object.docUrl);
    setFileExtention(object.docType);
    dispatch(
      _ser.downloadFileFromS3Async(selectedJob, actiontypeToApi, object.id),
    );
  };

  const guessNameFromUrl = (url) => {
    try {
      return decodeURIComponent(
        new URL(url).pathname.split("/").pop() || "download",
      );
    } catch {
      return "download";
    }
  };

  useEffect(() => {
    if (!docData) return;

    const run = async () => {
      try {
        if ((actionType || "").toLowerCase() === "download") {
          if (typeof docData === "string") {
            const filename =
              selectedDoc?.fileName || DocName || guessNameFromUrl(docData);
            const res = await fetch(docData, {
              cache: "no-store",
              credentials: "omit",
            });
            const blob = await res.blob();
            const href = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = href;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(href);
          } else {
            const filename =
              selectedDoc?.fileName ||
              DocName ||
              `document.${(fileExtention || "pdf").toLowerCase()}`;
            const blob =
              docData instanceof Blob ? docData : new Blob([docData]);
            const href = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = href;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(href);
          }
        } else if (actionType === "viewDocumentNewPage") {
          openDocumentInNewTab(docData, fileExtention);
        } else {
          setPreviewType(docData);
        }
      } finally {
        dispatch(_ser.downloadFileFromS3StartReducer(initalState));
      }
    };

    run();
  }, [docData]);

  const onReceivePropsHandler = (pannel, type) => {
    if (type === "documents") {
      setIsRightSidePannel(pannel);
      onReceiveProps(type);
    } else if(type === 'close') {
      setIsRightSidePannel(pannel);
    } else {
      DownloadFileFromS3(selectedDoc, type);
    }
  };

  return (
    <>
      {/* ── Action Bar ── */}
      <div
        className="detail-card-search"
        style={{ justifyContent: "flex-end" }}
      >
        <button
          type="button"
          className="detail-card-search__action-btn"
          onClick={() => {
            setIsRightSidePannel(true);
            setHandlerType("New document");
          }}
        >
          <DashboardPlusicon width={35} height={35} />
          <span>New Document</span>
        </button>
      </div>

      {/* ── Card Grid ── */}
      <div id="applicantDocs">
        {paginatedDocs.length > 0 ? (
          <div className="detail-card-grid detail-card-grid--docs ">
            {paginatedDocs.map((doc, idx) => (
              <DetailCard
                key={doc.id || idx}
                headerTitle={doc.docType || doc.documentType || "Resume"}
                badge={null}
                bodyFields={buildDocFields(doc)}
                footerActions={buildDocActions(doc)}
                testId={`doc-card-${doc.id || idx}`}
                className='jobdetails-document'
              />
            ))}
          </div>
        ) : (
          <div className="detail-card-empty">
            <img
              src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
              alt="No data"
            />
            No documents found
          </div>
        )}

        {/* ── Pagination ── */}
        <Pagination
          currentPage={currentPage}
          totalCount={documents.length}
          pageSize={CARDS_PER_PAGE}
          onPageChange={setCurrentPage}
          className="detail-card-pagination"
        />
      </div>

      {isRightSidePannel ? (
        <div id={HandlerType === "view" ? "documentViewer" : "uploadviewer"}>
          <RightSideBar
            componentData={
              <AddJobpostingDetailsDocuments
                HandlerType={HandlerType}
                JobId={selectedJob}
                previewType={previewType}
                DocName={DocName}
                fileExtention={fileExtention}
                onReceivePropsHandler={onReceivePropsHandler}
              />
            }
            componentLayout={HandlerType === "view" ? pannelobjview : pannelobj}
            footerImg={HandlerType !== "view" ? <AddDocumentsillus /> : null}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      ) : (
        <></>
      )}
      <WarningPopup
        open={showDeleteConfirm}
        handleClose={() => setShowDeleteConfirm(false)}
        handleConfirm={() => {
          DeleteDocuments(docToDelete);
          setShowDeleteConfirm(false);
        }}
        details={warningPopupDetails}
      />
    </>
  );
};

export default JobpostingDetailsDocuments;

const pannelobj = {
  title: "Add documents",
  description: "Browse files to upload",
  bgImage: <AddDocumentsillus />,
};

const pannelobjview = {
  title: "Document view",
  description: "",
  bgImage: "",
};